const CheckCircle2 = ({
  width = "54",
  height = "54",
  color = "#039CF2",
  ...rest
}) => (
  <svg
    {...rest}
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27 0.333374C12.3334 0.333374 0.333374 12.3334 0.333374 27C0.333374 41.6667 12.3334 53.6667 27 53.6667C41.6667 53.6667 53.6667 41.6667 53.6667 27C53.6667 12.3334 41.6667 0.333374 27 0.333374ZM38.2 22.4667L25.4 35.2667C24.3334 36.3334 22.7334 36.3334 21.6667 35.2667L15.8 29.4C14.7334 28.3334 14.7334 26.7334 15.8 25.6667C16.8667 24.6 18.4667 24.6 19.5334 25.6667L23.5334 29.6667L34.4667 18.7334C35.5334 17.6667 37.1334 17.6667 38.2 18.7334C39.2667 19.8 39.2667 21.4 38.2 22.4667Z"
      fill={color}
    />
  </svg>
);

export default CheckCircle2;
